<template lang="pug">
mixin tabTitle
  .title.mt-2.mb-4: block

div
  PageTitle: ModifiedDot.ml-2(:show='isModified' color='primary')
  v-card
    v-alert(type='error' :value='true' v-if='school === false' icon='warning') {{ $t('errorWhileLoading') }} {{ error }}
    v-alert(type='error' :value='true' v-else-if='isSaveFailed && error' icon='warning') {{ $t('failedToSave') }} {{ error.response }}

  .mb-5
    v-tabs(slider-color='primary' v-model='selectedTab' show-arrows)
      v-tab(v-for='(t, tIndex) in tabList' :key='tIndex' :disabled='!school') {{ $t(t) }}

    Loader(:show='school === null')

    v-form(ref='form' v-model='valid' v-if='school')
      v-tabs-items(v-model='selectedTab' :touchless='true')
        v-tab-item(v-for='(t, tIndex) in tabList' :key='tIndex')
          v-card-text
            v-container.pa-0(grid-list-sm v-if='t === `學校資訊`')
              v-layout(row wrap)
                v-flex(xs12 sm8)
                  +tabTitle
                    span.mr-2 {{ $t(t) }}
                    v-chip(
                      :color='school.isOpen ? `success` : ``'
                      :text-color='school.isOpen ? `white` : ``'
                      small
                    ) {{ school.isOpen ? $t("acceptingRegistration") : $t("closedRegistration") }}
                  v-switch(color='primary' v-model='school.isOpen')
                    template(slot='label') {{ $t('registrationStatus') }}: #[strong {{ school.isOpen ? $t('accepting') : $t('closed') }}]

                  v-text-field(:label='$t("label.name")' v-model.trim='school.name' :rules='rules.name' required)
                  v-textarea(:label='$t("label.formNote")' v-model='school.formNote' rows='6' v-if='isDefined(school.formNote)' :hint='$t("hint.formNote")')
                  v-text-field(:label='$t("label.statusMessage")' v-model.trim='school.statusMessage' :rules='rules.statusMessage' :hint='$t("hint.statusMessage")' :counter='50' v-if='isDefined(school.statusMessage)')

                  v-select(v-model='school.tags' :items='schoolClassificationList' item-value='value' item-text='label' :label='$t("label.category")' multiple chips deletable-chips small-chips :return-object='false')

                  template(v-if='school.preliminaryDate && round !== 1')
                    v-subheader.pl-0
                      | {{ $t("dateOfN", [$t("初賽")]) }}
                      v-btn(icon small flat color='primary' @click='addDateList(`preliminaryDate`)' :disabled='school.preliminaryDate.length >= 5'): v-icon(small) add
                    .pl-0
                      div(v-for='(i, index) in school.preliminaryDate')
                        DateTimePicker(:name='$t("初賽")' hide-time :show-delete='school.preliminaryDate.length > 0' @del='removeDateList(`preliminaryDate`, index)' v-model='school.preliminaryDate[index]')
                      h6.grey--text(v-if='!school.preliminaryDate.length') {{ $t("clickPlusToAdd") }}

                  template(v-if='school.finalDate && round === 3')
                    v-subheader.pl-0
                      | {{ $t("dateOfN", [$t("複賽")]) }}
                      v-btn(icon small flat color='primary' @click='addDateList(`finalDate`)' :disabled='school.finalDate.length >= 5'): v-icon(small) add
                    .pl-0
                      div(v-for='(i, index) in school.finalDate')
                        DateTimePicker(:name='$t("複賽")' hide-time :show-delete='school.finalDate.length > 0' @del='removeDateList(`finalDate`, index)' v-model='school.finalDate[index]')
                      h6.grey--text(v-if='!school.finalDate.length') {{ $t("clickPlusToAdd") }}

                  template(v-if='school.thirdRoundDate')
                    v-subheader.pl-0
                      | {{ $t("dateOfN", [$t("決賽")]) }}
                      v-btn(icon small flat color='primary' @click='addDateList(`thirdRoundDate`)' :disabled='school.thirdRoundDate.length >= 5'): v-icon(small) add
                    .pl-0
                      div(v-for='(i, index) in school.thirdRoundDate')
                        DateTimePicker(:name='$t("決賽")' hide-time :show-delete='school.thirdRoundDate.length > 0' @del='removeDateList(`thirdRoundDate`, index)' v-model='school.thirdRoundDate[index]')
                      h6.grey--text(v-if='!school.thirdRoundDate.length') {{ $t("clickPlusToAdd") }}

                v-flex(xs12 sm4)
                  v-subheader.pl-0
                    | {{ $t("label.avatar") }}
                    v-dialog(max-width=300 max-hegiht=500)
                      v-btn.ma-0(small icon flat :ripple='false' slot='activator'): v-icon(small color='grey') fas fa-question-circle
                      v-card: v-img(:src='require(`@/assets/img/where-avatar-is.png`)' cover)
                  ImageSelector(v-model='school.coverPhoto')
                  v-subheader.pl-0
                    | {{ $t("label.coverPhoto") }}
                    v-dialog(max-width=300 max-hegiht=500)
                      v-btn.ma-0(small icon flat :ripple='false' slot='activator'): v-icon(small color='grey') fas fa-question-circle
                      v-card: v-img(:src='require(`@/assets/img/where-cover-photo-is.png`)' cover)

                  ImageSelector(v-model='school.coverPhotoL')

            template(v-if='t === `帳務`')
              +tabTitle
                span {{ $t(t) }}
              v-alert.mb-3(:value='isECPay' type='info' outline)
                | 提示：欲設定各組別報名費請至#[router-link(:to='{ name: `groupConfig` }') 組別規則]
              Plan
              v-divider
              template(v-if='isECPay')
                v-subheader.pl-0 帳務資訊
                v-stepper(v-model='bankInfoStepper' v-if='bankInfoStepper >= 0')
                  v-stepper-header
                    v-stepper-step(:complete='bankInfoStepper > 1' step='1' editable edit-icon='$vuetify.icons.complete') 服務條款
                    v-divider
                    v-stepper-step(:complete='bankInfoStepper > 2' step='2') 輸入社團帳務資訊
                  v-stepper-items
                    //- 第 1 步
                    v-stepper-content(step='1')
                      PaymentTerms
                      v-btn(color='primary' depressed @click='bankInfoStepper = 2') 同意
                      //- v-btn(flat @click='bankInfoStepper = -1') 不同意
                    //- 第 2 步
                    v-stepper-content(step='2')
                      v-layout(row wrap)
                        v-flex(xs12 sm4)
                          v-autocomplete(:items='bankCodeList' item-text='label' item-value='code' label='銀行代碼' v-model.trim='school.bankCode')
                        v-flex
                          v-text-field(type='tel' label='銀行帳號' v-model.trim='school.bankAccount')
                      v-subheader.pl-0 存摺封面
                      ImageSelector(v-model='school.bankImage')

            template(v-if='t === `報名時間`')
              +tabTitle
                span {{ $t(t) }}
                v-tooltip(right)
                  v-btn.ma-0(small icon flat :ripple='false' slot='activator'): v-icon(small color='grey') fas fa-question-circle
                  span 決定是否允許參賽者報名與修改表單內容，但後台編輯表單則不受此限
              DateTimePicker(:name='$t("registrationDeadline")' v-model='school.participateDeadline')
              v-divider.my-3
              DateTimePicker(:name='$t("NSEditDeadline", [$t("初賽")])' v-model='school.editDeadline' v-if='round !== 1')
              DateTimePicker(:name='$t("NSEditDeadline", [$t("複賽")])' v-model='school.finalEditDeadline' v-if='round === 3')
              DateTimePicker(:name='$t("NSEditDeadline", [$t("決賽")])' v-model='school.thirdRoundEditDeadline')

            template(v-if='t === `共通自定義欄位`')
              +tabTitle
                span {{ $t(t) }}
                v-tooltip(right)
                  v-btn.ma-0(small icon flat :ripple='false' slot='activator'): v-icon(small color='grey') fas fa-question-circle
                  span 出現在所有組別表單的問答欄位
                v-btn.ma-0(color='primary' flat icon small @click='addCustomField()' v-if='school.commonField' :disabled='school.commonField.length >= 10'): v-icon(small) add

              template(v-if='school.commonField')
                h6.grey--text(v-if='!school.commonField.length') {{ $t('clickPlusToAdd') }}
                draggable(v-else v-model='school.commonField' handle='.handle')
                  div(v-for='(i, index) in school.commonField' :key='index')
                    v-layout(align-end)
                      v-flex(shrink): .handle.mr-2: v-icon(color='grey') dehaze
                      v-flex(grow)
                        CustomField(v-model='school.commonField[index]' :disabled='isHandling' :index='index' @remove='removeCustomField(index)')

            template(v-if='t === `人氣投票`')
              +tabTitle
                span.mr-2 {{ $t(t) }}
                v-chip(
                  :color='school.popularVote.isEnabled ? `success` : ``'
                  :text-color='school.popularVote.isEnabled ? `white` : ``'
                  small
                ) {{ school.popularVote.isEnabled ? `已啟用` : `關閉` }}
                v-chip(
                  v-if='school.popularVote.isEnabled'
                  :color='school.popularVote.isOpen ? `success` : ``'
                  :text-color='school.popularVote.isOpen ? `white` : ``'
                  small
                ) {{ school.popularVote.isOpen ? `開放投票` : `不開放投票` }}

              v-switch(color='primary' v-model='school.popularVote.isEnabled' hide-details)
                template(slot='label') 是否啟用:  #[strong  {{ school.popularVote.isEnabled ? `已啟用` : `關閉` }}]
              v-slide-y-transition(hide-on-leave)
                div(v-if='school.popularVote.isEnabled')
                  v-switch(color='primary' v-model='school.popularVote.isOpen')
                    template(slot='label') 是否開放投票:  #[strong  {{ school.popularVote.isOpen ? `是` : `否` }}]
                  DateTimePicker(:dateLabel='$t("nDate", [$t("start")])' :timeLabel='$t("nTime", [$t("start")])' v-model='school.popularVote.begin')
                  DateTimePicker(:dateLabel='$t("nDate", [$t("end")])' :timeLabel='$t("nTime", [$t("end")])' v-model='school.popularVote.end')

            v-container.pa-0(grid-list-sm v-if='t === `進階`')
              +tabTitle {{ $t(t) }}
              v-alert.mb-3(:value='school.isOpen' type='warning')
                | 開放報名期間無法變更以下設定。

              v-layout(row wrap)
                v-flex(xs12 sm6 lg4)
                  v-text-field(label='本屆(年度) *' v-model.trim.number='school.period' type='number' :rules='rules.period' required :disabled='school.isOpen')
                v-flex(xs12 sm12)
                  template(v-if='isDefined(round)')
                    v-subheader.pl-0 賽制:  #[strong {{ getRoundText(round) }}]
                    v-radio-group.mt-0(row v-model='round' :disabled='school.isOpen')
                      v-radio(:label='i.label' :value='i.value' color='primary' v-for='i in roundList' :key='i.value')

    StickyBottomSaveContent(:loading='!school || isSaving' :show='isModified' :disabled='!school || isSaving' :valid='valid' @submit='submit' @cancel='discard')

  SnackbarSuccess(ref='successSnackbar')
  DebugCodeBlock(:value='school')
</template>

<script>
import apis from '@/assets/js/apis'
import { formStatus } from '@/mixins/formStatus'

import Plan from '@/components/config/Plan.vue'
import PaymentTerms from '@/components/config/PaymentTerms.vue'
import CustomField from '@/components/config/CustomField.vue'

import DateTimePicker from '@/components/DateTimePicker.vue'
import Loader from '@/components/Loader.vue'
import ToolbarSaveContent from '@/components/ToolbarSaveContent.vue'
import StickyBottomSaveContent from '@/components/StickyBottomSaveContent.vue'
import SnackbarSuccess from '@/components/SnackbarSuccess.vue'
import PageTitle from '@/components/PageTitle.vue'
import ImageSelector from '@/components/ImageSelector.vue'
import GroupEdit from '@/views/GroupConfig.vue'
import draggable from 'vuedraggable'
import bankCode from '@/assets/json/taiwanBankCode.json'

export default {
  name: 'Config',
  metaInfo () {
    return {
      title: this.$t('設定'),
    }
  },
  data () {
    // 分頁列表
    this.tabList = ['學校資訊', '帳務', '報名時間', '共通自定義欄位', '人氣投票', '進階']
    // 輸入框規則
    this.rules = {
      name: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 30) || 'Name must be less than 20 characters',
      ],
      statusMessage: [
        v => (v.length <= 50) || 'Status Message must be less than 50 characters',
      ],
      period: [
        v => !!v || 'Period is required',
        v => (v && /^[0-9]*[1-9][0-9]*$/.test(v)) || 'Period must be a valid integer',
      ],
    }
    // 賽制列表
    this.roundList = [
      { value: 2, label: '兩輪' },
      { value: 1, label: '單輪' },
      { value: 3, label: '三輪' },
    ]
    return {
      school: null,
      selectedTab: 0,
      round: null,
      bankInfoStepper: 0,
      isHandling: false,
    }
  },
  mounted () {
    this.fetch()
    this.handleQuery()
  },
  methods: {
    async fetch () {
      this.school = null

      try {
        this.school = await apis.config.get(this.token) || null
        this.setRound()
        this.clearIsModified()
        this.setbankInfoStepper()
      } catch (e) {
        this.error = e
        this.school = false
      }
    },
    async submit () {
      if (!this.valid) return
      const body = { form: this.school }
      this.isSaving = true
      this.clearError()
      try {
        await apis.config.put(body, this.token)
        this.$emit('success')
        this.fetch()
        this.isSaving = false
        this.$refs.successSnackbar.show('成功發佈設定值')
        this.clearIsModified()
        this.$store.commit('setUserInfoLastUpdate', 0)
      } catch (e) {
        this.isSaveFailed = true
        this.isSaving = false
        this.error = e
      }
    },
    discard () {
      this.school = null
      this.clearIsModified()
      this.fetch()
    },
    addDateList (key) {
      this.school[key].push(+new Date())
    },
    removeDateList (key, index) {
      this.school[key].splice(index, 1)
    },
    addCustomField () {
      this.school.commonField.push({
        label: '',
        isRequired: false,
        isMultiLine: false,
      })
      this.valid = false
    },
    removeCustomField (index) {
      this.isHandling = true
      this.$nextTick(() => {
        this.school.commonField.splice(index, 1)
        this.isHandling = false
      })
    },
    isDefined (_) {
      return _ !== undefined && _ !== null
    },
    setRound () {
      const school = this.school
      if (!school) return

      if (school.isSingleRound === true) this.round = 1
      else if (school.isThirdRound === true) this.round = 3
      else if (school.isSingleRound === false && school.isThirdRound === false) this.round = 2
    },
    getRoundText (_) {
      const table = {
        1: '僅決賽', 2: '初賽和決賽', 3: '初賽、複賽和決賽',
      }
      return table[_] || '-'
    },
    // 處理網址參數
    handleQuery () {
      const query = this.$route.query
      if (query.page) this.selectedTab = +query.page
      else this.selectedTab = 0
    },
    // 根據帳務資訊的三個欄位，若其中一欄有被填過則視為已讀過條約，略過第一步讀條約部分，直接跳至填寫欄位
    setbankInfoStepper () {
      const _ = this.school
      if (_.bankCode || _.bankAccount || _.bankImage) this.bankInfoStepper = 2
    },
  },
  watch: {
    school: {
      handler (newValue) {
        this.isModified = true
      },
      deep: true,
    },
    round (_) {
      const school = this.school
      if (_ === 1) {
        school.isSingleRound = true
        school.isThirdRound = false
      } else if (_ === 2) {
        school.isSingleRound = false
        school.isThirdRound = false
      } else if (_ === 3) {
        school.isSingleRound = false
        school.isThirdRound = true
      }
    },
    selectedTab (_) {
      this.$router.replace({ query: { page: _ } })
        .catch(() => {})
    },
  },
  computed: {
    bankCodeList () {
      return bankCode.map(_ => {
        const label = `${_.code}(${_.name})`
        return { ..._, label }
      })
    },
  },
  components: {
    DateTimePicker,
    Loader,
    ToolbarSaveContent,
    StickyBottomSaveContent,
    SnackbarSuccess,
    PageTitle,
    ImageSelector,
    GroupEdit,
    draggable,
    Plan,
    PaymentTerms,
    CustomField,
  },
  mixins: [formStatus],
}
</script>

<style scoped lang="sass">
code
  margin-right: .5rem

.sticky
  position: sticky
  top: 5rem
  z-index: 2
  width: 100%
  left: 0
  right: 0
</style>

<i18n src="@/lang/views/config.json"></i18n>
